<template>
  <div
    ><ContentWrap title="直播模板"
      ><el-form :inline="true"
        ><el-form-item label="名称"
          ><el-input show-word-limit :maxlength="64" v-model="q.name" clearable /></el-form-item
        ><el-form-item
          ><el-button type="primary" @click="load">查询</el-button
          ><el-button @click="open()"><Icon icon="ep:plus" />新建模板</el-button></el-form-item
        ></el-form
      ></ContentWrap
    ><ContentWrap
      ><el-row :gutter="18"
        ><el-col v-for="x in list" :key="x.id" :span="6"
          ><el-card class="tpl" shadow="hover"
            ><el-image :src="x.coverUrl || defaultCover" class="cover"
              ><template #error
                ><div class="cover-empty"><Icon icon="ep:video-camera" /></div></template></el-image
            ><h3>{{ x.name }}</h3
            ><p>{{ x.description || '暂无模板说明' }}</p
            ><div
              ><el-tag>{{ sceneTypeName(x.sceneType) }}</el-tag
              ><span>V{{ x.version }}</span></div
            ><footer
              ><el-button link type="primary" @click="open(x)">编辑</el-button
              ><el-button link type="danger" @click="del(x.id)">删除</el-button></footer
            ></el-card
          ></el-col
        ></el-row
      ><el-empty v-if="!list.length && !loading" description="暂无直播模板" /><Pagination
        v-model:page="q.pageNo"
        v-model:limit="q.pageSize"
        :total="total"
        @pagination="load" /></ContentWrap
    ><Dialog v-model="visible" :title="form.id ? '编辑模板' : '新建模板'" width="570px"
      ><el-form
        ref="refForm"
        :model="form"
        :rules="withLiveInputLimits(rules, liveInputLimits)"
        label-width="90px"
        ><el-form-item label="模板名称" prop="name"
          ><el-input show-word-limit :maxlength="64" v-model="form.name" /></el-form-item
        ><el-form-item prop="coverUrl" label="模板封面"><UploadImg v-model="form.coverUrl" /></el-form-item
        ><el-form-item prop="category" label="模板分类"
          ><el-select v-model="form.category" class="w-full"
            ><el-option label="赛事直播" value="赛事直播" /><el-option
              label="课程直播"
              value="课程直播" /><el-option
              label="综合直播"
              value="综合直播" /></el-select></el-form-item
        ><el-form-item label="适用类型" prop="sceneType"
          ><el-select v-model="form.sceneType" class="w-full" placeholder="请选择适用业务模块"
            ><el-option
              v-for="item in sceneTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value" /></el-select></el-form-item
        ><el-form-item prop="description" label="模板说明"
          ><el-input
            show-word-limit
            :maxlength="500"
            v-model="form.description"
            type="textarea"
            :rows="3" /></el-form-item
        ><el-form-item label="状态"
          ><el-radio-group v-model="form.status"
            ><el-radio :value="0">停用</el-radio
            ><el-radio :value="1">启用</el-radio></el-radio-group
          ></el-form-item
        ></el-form
      ><template #footer
        ><el-button @click="visible = false">取消</el-button
        ><el-button type="primary" @click="save">保存</el-button></template
      ></Dialog
    ></div
  >
</template>
<script setup lang="ts">
import { withLiveInputLimits } from '@/utils/liveInputLimits'
const liveInputLimits = {
  name: 64,
  description: 500,
  code: 64,
  category: 32,
  sceneType: 32,
  coverUrl: 512
}

import { ContentWrap } from '@/components/ContentWrap'
import { Dialog } from '@/components/Dialog'
import * as Api from '@/api/live/template'
import * as ModuleApi from '@/api/system/module/index'
const sceneTypeOptions = ref<Array<{ label: string; value: string }>>([
  { label: '通用直播', value: 'general' }
])
const defaultCover =
  'data:image/svg+xml;charset=UTF-8,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="640" height="260"><rect width="100%" height="100%" fill="#243b68"/><text x="50%" y="52%" fill="#fff" font-size="32" text-anchor="middle">直播模板</text></svg>'
  )
const sceneTypeName = (value?: string) =>
  sceneTypeOptions.value.find((item) => item.value === value)?.label || value || '通用直播'
const message = useMessage(),
  loading = ref(false),
  visible = ref(false),
  list = ref<any[]>([]),
  total = ref(0),
  refForm = ref(),
  q = reactive({ pageNo: 1, pageSize: 12, name: '' }),
  form = reactive<any>({}),
  rules = {
    name: [{ required: true, message: '请输入模板名称' }],
    sceneType: [{ required: true, message: '请选择适用类型' }]
  }
async function load() {
  loading.value = true
  try {
    const r = await Api.getTemplatePage(q)
    list.value = r.list || []
    total.value = r.total || 0
  } finally {
    loading.value = false
  }
}
async function loadSceneTypes() {
  const modules = await ModuleApi.getEnabledModuleList()
  sceneTypeOptions.value = [
    { label: '通用直播', value: 'general' },
    ...(modules || [])
      .filter((item: any) => item.name && item.name !== 'live')
      .map((item: any) => ({ label: item.title || item.name, value: item.name }))
  ]
}
function open(x?: any) {
  Object.assign(
    form,
    x
      ? { ...x }
      : {
          id: undefined,
          name: '',
          coverUrl: '',
          category: '综合直播',
          sceneType: 'general',
          description: '',
          status: 1,
          pageConfig: '{}',
          featureConfig: '{}',
          playerConfig: '{}'
        }
  )
  visible.value = true
}
async function save() {
  await refForm.value?.validate()
  form.id ? await Api.updateTemplate(form) : await Api.createTemplate(form)
  message.success('保存成功')
  visible.value = false
  load()
}
async function del(id: number) {
  await message.delConfirm()
  await Api.deleteTemplate(id)
  message.success('删除成功')
  load()
}
onMounted(() => {
  loadSceneTypes()
  load()
})
</script>
<style scoped>
.tpl {
  margin-bottom: 18px;
}
.cover {
  width: 100%;
  height: 130px;
  border-radius: 8px;
}
.cover-empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #243b68, #587fc4);
  color: #fff;
  font-size: 35px;
}
.tpl h3 {
  margin: 13px 0 7px;
}
.tpl p {
  height: 38px;
  margin: 0;
  color: #8a94a4;
  font-size: 13px;
}
.tpl > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #99a2af;
  font-size: 12px;
}
.tpl footer {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid #eee;
  text-align: right;
}
</style>
